import { ModuleWithProviders, NgModule } from '@angular/core';
import { ErrorHandlerService } from '@orthofi/ngx-error-handler/error-handler.service';
import { OfiAuthenticatedUserAPIService } from './ofi-authenticated-user.service';
import { OfiAuthenticatedUserAPIServiceStub } from './ofi-authenticated-user.service.stub';

/**
 * When imported in to a module and `.forRoot()` is called, the `OfiAuthenticatedUserAPIService` is provided to the module.
 * This is an HTTP service that can be called to get the information for the logged in user. Additionally, there are utilities
 * included (which may be moved later) for checking users.
 */
@NgModule({
    providers: [ OfiAuthenticatedUserAPIService ]
})
export class FoundationAuthenticatedUserAPIModule {
    static forRoot (): ModuleWithProviders<FoundationAuthenticatedUserAPIModule> {
        return {
            ngModule: FoundationAuthenticatedUserAPIModule,
            providers: [ OfiAuthenticatedUserAPIService, ErrorHandlerService ]
        };
    }
}

/**
 * When imported in to a module and `.forRoot()` is called, the `OfiAuthenticatedUserAPIServiceStub` is provided to the module.
 * This is a stub of the respective HTTP service, including it's utilities, to be used inside tests.
 */
@NgModule({
    providers: [ OfiAuthenticatedUserAPIServiceStub ]
})
export class FoundationAuthenticatedUserAPITestingModule {
    static forRoot (): ModuleWithProviders<FoundationAuthenticatedUserAPITestingModule> {
        return {
            ngModule: FoundationAuthenticatedUserAPITestingModule,
            providers: [ ErrorHandlerService, { provide: OfiAuthenticatedUserAPIService, useClass: OfiAuthenticatedUserAPIServiceStub } ]
        };
    }
}
